const initializedSections = new WeakSet();

const initSolutionsProcess = (scope = document) => {
  const sections = scope.matches?.('.solutions-process-sec')
    ? [scope]
    : scope.querySelectorAll('.solutions-process-sec');

  sections.forEach((section) => {
    if (initializedSections.has(section)) return;

    const items = Array.from(section.querySelectorAll('.solutions-process-sec__item'))
      .map((item) => ({
        item,
        trigger: item.querySelector('.solutions-process-sec__trigger'),
        panel: item.querySelector('.solutions-process-sec__panel'),
      }))
      .filter(({ trigger, panel }) => trigger && panel);

    if (!items.length) return;
    initializedSections.add(section);

    const select = (selected) => {
      items.forEach(({ item, trigger, panel }, index) => {
        const isOpen = index === selected;
        item.classList.toggle('is-open', isOpen);
        trigger.setAttribute('aria-expanded', String(isOpen));
        panel.setAttribute('aria-hidden', String(!isOpen));
        panel.hidden = !isOpen;
        panel.toggleAttribute('inert', !isOpen);
      });
    };

    select(0);
    section.addEventListener('click', (event) => {
      const trigger = event.target.closest?.('.solutions-process-sec__trigger');
      const index = items.findIndex((item) => item.trigger === trigger);
      if (index !== -1) select(index);
    });

    section.addEventListener('keydown', (event) => {
      const index = items.findIndex((item) => item.trigger === event.target);
      if (index === -1) return;

      let next;
      if (event.key === 'ArrowDown') next = (index + 1) % items.length;
      if (event.key === 'ArrowUp') next = (index - 1 + items.length) % items.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = items.length - 1;
      if (next === undefined) return;

      event.preventDefault();
      items[next].trigger.focus();
      select(next);
    });
  });
};

initSolutionsProcess();
window.initSolutionsProcess = initSolutionsProcess;
